import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { editorConfig } from '../../../config/ckeditorConfig';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useUpdateCms } from '../api/homepageApi';
import { useToast } from '../../../hooks/usetoast';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import { queryClient } from '../../../config';
import PropTypes from 'prop-types';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';


function EditAbout({ editData, toggleEdit }) {
    const schema = yup.object().shape({
        ...(editData?.title === "Features" && {
            image: yup.mixed()
                .test("required", "Image is required", file => !!file)
                .required("Image is required"),
        }),
        heading: yup.string().required('Required'),
        content: yup.string().required('Required'),
    });

    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        register,
    } = useForm({
        mode: 'onBlur',
        resolver: yupResolver(schema),
        defaultValues: {
            heading: '',
            content: '',
        }
    });

    const [isloading, setIsloading] = useState(false);

    const updateCms = useUpdateCms();
    const toast = useToast();

    useEffect(() => {
        if (editData) {
            reset({
                heading: editData.heading || '',
                content: editData.content || '',
            });
        }
    }, [editData, reset]);

    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Homepage Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };



    const onSubmit = async (data) => {
        setIsloading(true);
        const formData = new FormData();
        formData.append("id", editData?._id);
        formData.append("heading", data.heading);
        formData.append("content", data.content);

        const response = await updateCms.mutateAsync(formData);

        if (response) {
            setIsloading(false);
            if (response.status) {
                toast.success(response?.data?.message, {
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 2000,
                });
                toggleEdit();
                queryClient.refetchQueries("cms");
            } else {
                toast.error(response?.data?.message || "Something went wrong", {
                    showOnlyTheLastOne: true,
                    clickToClose: true,
                    timeout: 2000,
                });
            }
        }
    };

    let content;

    if (isloading) {
        content = <WaitingLoader />;
    } else if (access) {
        content = (
            <form onSubmit={handleSubmit(onSubmit)} className='minW50'>
                <div className='p-2' style={{ width: '400px' }}>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <h4>{editData?.title}</h4>
                    </div>

                    {/* Heading Field */}
                    <div className='mb-3'>
                        <label className="form-label" htmlFor="heading">Heading</label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                {...register('heading')}
                                autoComplete='off'
                            />
                        </div>
                        {errors.heading && (
                            <span className="text-danger">{errors.heading.message}</span>
                        )}
                    </div>

                    {/* Content Field */}
                    <div className='mb-3'>
                        <label className="form-label" htmlFor="content">Content</label>
                        <Controller
                            name="content"
                            control={control}
                            render={({ field }) => (
                                <CKEditor
                                    editor={ClassicEditor}
                                    config={editorConfig}
                                    data={field.value}
                                    onChange={(event, editor) => {
                                        const data = editor.getData();
                                        field.onChange(data);
                                    }}
                                />
                            )}
                        />
                        {errors.content && (
                            <span className="text-danger">{errors.content.message}</span>
                        )}
                    </div>

                    <div className='d-flex justify-content-center'>
                        <button
                            type='submit'
                            className='btn btn-primary'
                            disabled={isloading}
                        >
                            Update
                        </button>
                    </div>
                </div>
            </form>
        );
    } else {
        content = <PermissionDenied />;
    }

    return <>{content}</>;

}

EditAbout.propTypes = {
    editData: PropTypes.object,
    toggleEdit: PropTypes.func,
};

export default EditAbout;